import { apiClient } from '@/lib/api-client';
import type {
  EmailMessage,
  ListEmailMessagesInput,
  Paginated,
  RetryFailedEmailInput,
} from '../../domain/entities/notify.entity';

export class NotifyApiDatasource {
  async listEmails(
    input?: ListEmailMessagesInput,
  ): Promise<Paginated<EmailMessage>> {
    const { data } = await apiClient.get<Paginated<EmailMessage>>(
      '/admin/notify/emails',
      {
        params: {
          page: input?.page ?? 1,
          perPage: input?.perPage ?? 10,
        },
      },
    );
    return data;
  }

  async retryEmail(
    id: string,
    body: RetryFailedEmailInput,
  ): Promise<EmailMessage> {
    const { data } = await apiClient.post<EmailMessage>(
      `/admin/notify/emails/${id}/retry`,
      body,
    );
    return data;
  }
}
